/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2552
 */

var r = require(/* 861 */"../../../../2466/2467/727/861")
var i = r ? r.prototype : undefined
var o = i ? i.valueOf : undefined
module.exports = function (e) {
  return o ? Object(o.call(e)) : {}
}
